module.exports = "<div class=\"image-library-dropzone\" ngf-drop=\"\" ng-model=\"files\" ngf-model-invalid=\"invalidFiles\" ngf-drag-over-class=\"dragover\" ngf-multiple=\"true\" ngf-max-size=\"5000000\" ngf-accept=\"'image/*'\" ngf-pattern=\"'.jpg,.jpeg,.png,.gif'\"> <div class=\"image-library-dropzone__content\"> <div class=\"image-library-dropzone__circle\"> <md-icon class=\"image-library-dropzone__icon\">file_upload</md-icon> </div> <div class=\"image-library-dropzone__text\">{{'IMAGELIBRARY.UPLOAD' | translate}}</div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/imageLibrary/imageLibraryDropzone.html
// module id = 1267
// module chunks = 28